import { hasMatches, isArrayObjectMatch, pathRegex, tryJSON } from "./object.utilities";

/**
 *
 * traverse an object with custom path
 *
 * eg.
 * a.b.c
 * a.{id:"dd"}.d
 *
 */
export function traverseObjectPath<Value>(
  path: string,
  srcObject: unknown,
  mutate?: boolean,
): Value | undefined {
  const fragments = (path || "").split(pathRegex);

  let fragment = fragments.shift();

  let _head = mutate ? srcObject : JSON.parse(JSON.stringify({ dup: srcObject })).dup;

  while (fragment && _head) {
    if (isArrayObjectMatch(fragment)) {
      const findObj = tryJSON(fragment);
      if (!Array.isArray(_head) || !findObj) {
        _head = undefined;
        break;
      }
      _head = _head.find(hasMatches(findObj));
    } else {
      _head = _head[fragment];
    }

    fragment = fragments.shift();
  }

  if (!_head) {
    return undefined;
  }

  if (mutate) {
    return _head as Value;
  }

  if (Array.isArray(_head)) {
    return [..._head] as unknown as Value;
  } else if (_head !== null && typeof _head === "object") {
    // THINK: don't spread here, you lose the instantiated type? (ie, Timestamp)
    // return targetObj;
    return { ..._head };
  } else {
    return _head as Value;
  }
}
